import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BpAdministrationService} from '../../../../../services/bp-administration.service';
import {AdminService} from '../../../../../services/admin.service';
import {HumanInteractionService} from '../../../../../services/human-interaction.service';
import {DateTimeService} from '../../../../../services/date-time.service';
import {BusinessProcessService} from '../../../../../services/business-process.service';
import {AccessControlService} from '../../../../../services/access-control.service';
import {CustomValidator} from '../../../../../services/custom-validator';

@Component({
  selector: 'app-queue-manager-filter',
  templateUrl: './queue-manager-filter.component.html',
  styleUrls: ['./queue-manager-filter.component.css']
})
export class QueueManagerFilterComponent implements OnInit  {

  @Input() isCustom = false;
  @Output() filtered: EventEmitter<any> = new EventEmitter();
  @Output() filteredCustom: EventEmitter<any> = new EventEmitter();
  @Output() retPleaseWait: EventEmitter<boolean> = new EventEmitter();

  pleaseWait = false;
  filterForm: FormGroup;
  availableBp;
  availableState = [];
  availableUsers;
  availableCustomQueueConfig;


  columnList: any[];
  columnInfo;
  columnValue;
  locale = 'pt-br';
  enableFieldsCol = true;
  enableFieldsValue = false;
  enableAddButtonCol = false;
  hasOnlySpaces = false;
  searchForLimit = 5;
  allowedColumnOnCustomQueue = true;
  customQueueColumnsError = '';

  errorMessage = '';
  successMessage = '';

  allocatedOptions = [
    { label: 'Todas', value: '?' },
    { label: 'Somente propostas alocadas', value: '0' },
    { label: 'Somente propostas desalocadas', value: '1' }
  ];

  get formData() { return this.filterForm.controls; }

  constructor(private formBuilder: FormBuilder, private bpAdm: BpAdministrationService, private admService: AdminService, private accessControlService: AccessControlService,
              private humanInteractionService: HumanInteractionService, private dateTimeService: DateTimeService, private bpService: BusinessProcessService) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.retPleaseWait.next(true);
    this.createForm();
    this.loadUsers();

    this.loadBpList();
    if (this.isCustom) {
      this.loadCustomQueueConfig();
    } else {
      this.getQueue();
    }
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      businessProcessId: null,
      stateId: [{ value: null, disabled: true }],
      userLogon: null,
      lockedInstances: false,
      columnsComparisonType: 1,
      columns: [[]],
      initialDate: [null],
      finalDate: [null],
      customInteractionQueueConfigId: [{ value: null, disabled: true }],
      isAllocated: '?'
    });
    this.filterForm.setValidators(CustomValidator.validateDatetime('initialDate', 'finalDate'));
    if (this.isCustom) {
      this.filterForm.get('userLogon').disable();
    }
  }

  loadBpList() {
    if (this.isCustom) {
      this.bpService.getAllBusinessProcessesPublished().subscribe(result => {
        this.availableBp = result;
      }, error1 => {
        this.errorMessage = error1;
      });
    } else {
      this.bpAdm.getBusinessProcessesForManaging().subscribe(result => {
        this.availableBp = result;
      }, error1 => {
        this.errorMessage = error1;
      });
    }
  }

  loadStates(businessProcessId) {
    if (!this.isCustom) {
      this.bpAdm.getStatesForManaging(businessProcessId).subscribe(result => {
        this.availableState = result;
        this.setDisableConfig(result.length > 0, 'stateId');
      }, error1 => {
        this.errorMessage = error1;
      });
    } else {
      this.bpService.getStatesByBusinessProcessId(businessProcessId).subscribe(result => {
        this.availableState = result;
        this.setDisableConfig(result.length > 0, 'stateId');
        if (result.length > 0) {
          this.loadCustomUsers();
        }

        const selectedState = result.filter(f => f.stateId == this.formData.stateId.value);
        if (selectedState && selectedState.length == 0) {
          this.formData.stateId.setValue(null);
        }
      });
    }

  }

  setDisableConfig(enable: boolean, formControlName: string) {
    if (enable) {
      this.filterForm.get(formControlName).enable();
    } else {
      this.filterForm.get(formControlName).disable();
    }
  }

  loadUsers() {
    if (!this.isCustom) {
      this.admService.loadDropdownContent('api/admin/loadAllUsersDropDown').subscribe(result => {
        this.availableUsers = result;
      }, error1 => {
        this.errorMessage = error1;
      });
    }
  }

  loadCustomUsers() {
    const states = this.availableState.map(m => m.stateId);
    this.accessControlService.getUsersWithEffectivePermissionOnAnyState(states, 'Interagir').subscribe(result => {
      this.availableUsers = result.map(m => ({ id: m.userId, name: m.logon, enabled: m.enabled }));
      if (result.length > 0) {
        this.filterForm.get('userLogon').enable();
      } else {
        this.filterForm.get('userLogon').disable();
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  loadCustomQueueConfig(businessProcessId = null, stateId = null) {
    if (!this.formData.customInteractionQueueConfigId.value) {
      this.columnInfo = null;
      this.columnValue = null;
      this.filterForm.controls['columns'].setValue([]);
      this.customQueueColumnsError = '';
    }
    const formControlName = 'customInteractionQueueConfigId';
    this.availableCustomQueueConfig = [];
    // this.formData.customInteractionQueueConfigId.setValue(null);
    this.setDisableConfig(false, formControlName);

    this.humanInteractionService.getCustomInteractionQueueConfig(businessProcessId, stateId).subscribe(result => {
      this.availableCustomQueueConfig = result;
      const selectedCustomQueue = result.filter(f => f.id == this.formData.customInteractionQueueConfigId.value);
      if (selectedCustomQueue && selectedCustomQueue.length == 0) {
        this.formData.customInteractionQueueConfigId.setValue(null);
      }
      this.setDisableConfig(result.length > 0, formControlName);
      this.pleaseWait = false;
      this.retPleaseWait.next(false);
    }, error1 => {
    });
  }

  getQueue() {
    this.errorMessage = '';
    if (!this.isCustom) {
      this.humanInteractionService.getInteractionQueue().subscribe( queue => {
        this.columnList = queue.columns.filter(f => f.systemField !== 5);
        this.pleaseWait = false;
        this.retPleaseWait.next(false);
      }, error1 => {
        this.errorMessage = error1;
        console.log(error1);
      });
    } else {
      if (this.availableCustomQueueConfig && this.availableCustomQueueConfig.length > 0) {
        let fieldColumnSelected = this.availableCustomQueueConfig.filter(f => f.id == this.formData.customInteractionQueueConfigId.value)[0];
        if (fieldColumnSelected) {
          this.columnList = fieldColumnSelected.fieldColumns.filter(f => f.systemField != 8 && f.systemField != 5);
        }
      }
    }

  }

  changeBP(element) {
    if (this.isCustom && element === undefined && this.formData.customInteractionQueueConfigId.value === null) {
      this.formData.userLogon.setValue(null);
      this.setDisableConfig(false, 'userLogon');
    }
    this.changeState(element);
    if (this.isCustom) {
      if (element !== undefined) {
        this.loadCustomQueueConfig(element.businessProcessId);
      } else {
        this.loadCustomQueueConfig();
      }
    }
  }

  changeState(element) {
    if (!this.isCustom) {
      this.availableState = [];
      this.formData.stateId.setValue(null);
      this.setDisableConfig(false, 'stateId');

      if (element !== undefined) {
        this.loadStates(element.businessProcessId);
      }
    } else {
      this.changeStateCustom();
    }
  }

  changeStateCustom() {
    const bpFilter = this.filterForm.get('businessProcessId').value;
    const customQueueFilter = this.filterForm.get('customInteractionQueueConfigId').value;

    let bpParam = 0;
    if (bpFilter != undefined || bpFilter != null) {
      bpParam = bpFilter;
    } else if (customQueueFilter != undefined || customQueueFilter != null) {
      let fieldColumnSelected = this.availableCustomQueueConfig.filter(f => f.id == customQueueFilter)[0];
      bpParam = fieldColumnSelected.businessProcessId;
    } else {
      this.formData.stateId.setValue(null);
      this.availableState = [];
      this.setDisableConfig(false, 'stateId');
    }

    if (bpParam !== 0) {
      this.loadStates(bpParam);
    }
  }

  changeRegularUser(element) {
    if (element !== undefined) {
      this.formData.lockedInstances.setValue(false);
    }
  }

  changeCustomQueue(element) {
    this.columnInfo = null;
    this.columnValue = null;
    this.filterForm.controls['columns'].setValue([]);
    this.customQueueColumnsError = '';
    if (element === undefined && this.formData.businessProcessId.value === null) {
      this.formData.userLogon.setValue(null);
      this.setDisableConfig(false, 'userLogon');
    }
    this.getQueue();
    this.changeStateCustom();
  }

  getElementId(desc) {
    if (this.isCustom) {
      desc += 'Custom';
    }
    return desc;
  }

  resetFilter() {
    this.availableState = [];
    this.columnInfo = null;
    this.columnValue = null;
    this.enableFieldsValue = false;
    this.enableAddButtonCol = false;
    this.setDisableConfig(false, 'stateId');
    if (this.isCustom) {
      this.customQueueColumnsError = '';
      this.formData.userLogon.setValue(null);
      this.setDisableConfig(false, 'userLogon');
      this.loadCustomQueueConfig();
    }
    this.createForm();
  }

  // search for columns
  clearValue(event) {
    this.columnValue = '';
    // habilitar o campo de valor se houver alguma coluna selecionada.
    this.enableFieldsValue = event !== undefined;
    if (!this.enableFieldsValue) {
      this.hasOnlySpaces = false;
    }
    if (event === undefined) {
      this.enableAddButtonCol = false;
    } else {
      if (this.isCustom) { this.checkOneValueToOneColumn(event.name); }
    }

  }

  removeColumnValue(item: any) {
    let array = this.filterForm.controls['columns'].value;
    array.splice(array.findIndex(v => v.value === item.value && v.id === item.id), 1);
    this.filterForm.controls['columns'].setValue(array);
    this.checkOneValueToOneColumn(this.columnInfo.name);
  }

  addColumnValue() {
    let array = this.filterForm.controls['columns'].value;
    if (this.isCustom) {
      array.push({
          id: this.columnInfo.columnOrder + 1,
          name: this.columnInfo.name,
          value: this.columnValue.toString().trim()
        });
      this.checkOneValueToOneColumn(array[array.length - 1].name);
    } else {
      array.push( {
          id: this.columnInfo.id,
          name: this.columnInfo.name,
          value: this.columnValue.toString().trim()
        });
    }
    this.filterForm.controls['columns'].setValue(array);
    this.columnValue = '';
    this.enableAddButtonCol = false;
  }

  validateRequiredColumnValue() {
    const qtd = this.filterForm.controls['columns'].value.length;
    return ((this.columnValue === '' || this.columnValue === undefined) && this.enableFieldsValue && !this.hasOnlySpaces)
      && ((qtd <= this.searchForLimit - 1 && !this.isCustom) || (this.isCustom && qtd < 1));
  }

  disableSubmitButtonCondition() {
    return (this.formData.initialDate.value && !this.formData.finalDate.value)
      || (!this.formData.initialDate.value && this.formData.finalDate.value)
      || !this.filterForm.valid
      || (this.enableFieldsValue && this.columnValue !== '' && this.columnValue !== null)
      || (this.isCustom && this.availableCustomQueueConfig && this.availableCustomQueueConfig.length == 0)
      || (this.isCustom && this.formData.businessProcessId.value == null && this.formData.customInteractionQueueConfigId.value == null)
      || this.pleaseWait;
  }

  enableAddButton(event) {
    if (event.target.value.length > 0) {
      this.hasOnlySpaces = event.target.value.toString().trim() === '';
    } else {
      this.hasOnlySpaces = false;
    }
    this.enableAddButtonCol = event.target.value.toString().trim() !== '';
  }

  validateAddButton() {
    const qtd = this.filterForm.controls['columns'].value.length;
    return !this.enableAddButtonCol || (!(qtd < this.searchForLimit) && !this.isCustom)
      || (this.isCustom && !this.allowedColumnOnCustomQueue);
  }

  checkOneValueToOneColumn(selectedColumnName: string) {
    this.customQueueColumnsError = '';
    this.allowedColumnOnCustomQueue = false;
    const namesOnArray = this.filterForm.controls['columns'].value.map( column => column.name);

    if (namesOnArray.length === 0) {
      this.allowedColumnOnCustomQueue = true;
    }

    if (namesOnArray.includes(selectedColumnName)) {
      this.customQueueColumnsError = 'Essa coluna já foi inserida';
      this.allowedColumnOnCustomQueue = false;
    } else {
      this.allowedColumnOnCustomQueue = true;
    }
  }
  // end - search for columns

  // period
  blockUserInput() {
    return false;
  }
  // end - period

  search() {
    const filter = this.filterForm.getRawValue();

    this.collapseFilterWhenSearching();

    if (!this.isCustom) {
      filter.initialDate = this.dateTimeService.toUTC(filter.initialDate);
      filter.finalDate = this.dateTimeService.toUTC(filter.finalDate);
      this.filtered.emit(filter);

    } else {
      delete filter.columnsComparisonType;
      delete filter.lockedInstances;
      filter.stateLifeCycles = filter.isAllocated == '0' ? [8, 11] : filter.isAllocated == '1' ? [7] : [8, 7, 11];
      delete filter.isAllocated;
      filter.orderDirection = 1;
      if (filter.customInteractionQueueConfigId != null) {
        filter.customInteractionQueueConfigId = [ filter.customInteractionQueueConfigId ];
      } else {
        filter.customInteractionQueueConfigId = this.availableCustomQueueConfig.map(m => m.id);
      }


      this.filteredCustom.emit(filter);
    }
  }

  collapseFilterWhenSearching() {
    // fechar o filtro
    const collapseFilter = document.getElementById(this.getElementId('collapseFilter'));
    collapseFilter.classList.add('fa-plus');
    collapseFilter.classList.remove('fa-minus');
    const bodyFilter = document.getElementById(this.getElementId('bodyFilter'));
    const footerFilter = document.getElementById(this.getElementId('footerFilter'));
    bodyFilter.style.display = footerFilter.style.display = 'none';
  }

}
